export default () => ({
  promotedFilterEnable: false,
  promotedByDateRangeMode: '',
  /**
    * @type {import('@typings/search').DateRangeItem}
    */
  promoteDateObject: {},
});
